import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Plus, Search, Eye, Edit, ShoppingCart } from "lucide-react";
import { motion } from "framer-motion";

const orders = [
  { id: "ORD-001", customer: "Ahmed Khan", car: "Toyota Corolla 2024", date: "2026-03-28", total: "₨ 5,350,000", status: "Completed", payment: "Paid" },
  { id: "ORD-002", customer: "Muhammad Ali", car: "Honda Civic 2023", date: "2026-03-27", total: "₨ 6,900,000", status: "Processing", payment: "Partial" },
  { id: "ORD-003", customer: "Hassan Raza", car: "KIA Sportage 2023", date: "2026-03-25", total: "₨ 8,600,000", status: "Pending", payment: "Unpaid" },
  { id: "ORD-004", customer: "Usman Sheikh", car: "Hyundai Tucson 2024", date: "2026-03-24", total: "₨ 9,300,000", status: "Completed", payment: "Paid" },
  { id: "ORD-005", customer: "Bilal Ahmad", car: "Suzuki Alto 2024", date: "2026-03-22", total: "₨ 2,950,000", status: "Delivered", payment: "Paid" },
];

const Orders = () => {
  return (
    <Layout title="Orders">
      <div className="space-y-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div>
            <h1 className="text-2xl font-display font-bold text-foreground">Orders</h1>
            <p className="text-sm text-muted-foreground mt-1">Track and manage car orders</p>
          </div>
          <Button variant="premium" className="gap-2"><Plus className="w-4 h-4" /> New Order</Button>
        </div>

        <div className="relative max-w-md">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
          <Input placeholder="Search orders..." className="glass-input pl-9 h-10" />
        </div>

        <div className="glass-card overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-border/30">
                  {["Order ID", "Customer", "Car", "Date", "Total", "Status", "Payment", "Actions"].map(h => (
                    <th key={h} className="text-left text-xs font-medium text-muted-foreground px-5 py-3">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {orders.map((o, i) => (
                  <motion.tr key={o.id} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: i * 0.05 }} className="border-b border-border/20 hover:bg-secondary/30 transition-colors">
                    <td className="px-5 py-3.5">
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center">
                          <ShoppingCart className="w-3.5 h-3.5 text-primary" />
                        </div>
                        <span className="text-sm font-medium text-primary">{o.id}</span>
                      </div>
                    </td>
                    <td className="px-5 py-3.5 text-sm text-foreground">{o.customer}</td>
                    <td className="px-5 py-3.5 text-sm text-muted-foreground">{o.car}</td>
                    <td className="px-5 py-3.5 text-sm text-muted-foreground">{o.date}</td>
                    <td className="px-5 py-3.5 text-sm font-medium text-foreground">{o.total}</td>
                    <td className="px-5 py-3.5">
                      <span className={`text-xs px-2.5 py-1 rounded-full font-medium ${
                        o.status === "Completed" || o.status === "Delivered" ? "bg-success/10 text-success" :
                        o.status === "Processing" ? "bg-info/10 text-info" :
                        "bg-warning/10 text-warning"
                      }`}>{o.status}</span>
                    </td>
                    <td className="px-5 py-3.5">
                      <span className={`text-xs px-2.5 py-1 rounded-full font-medium ${
                        o.payment === "Paid" ? "bg-success/10 text-success" :
                        o.payment === "Partial" ? "bg-warning/10 text-warning" :
                        "bg-destructive/10 text-destructive"
                      }`}>{o.payment}</span>
                    </td>
                    <td className="px-5 py-3.5">
                      <div className="flex items-center gap-1">
                        <Button variant="ghost" size="icon" className="h-7 w-7 text-muted-foreground hover:text-foreground"><Eye className="w-3.5 h-3.5" /></Button>
                        <Button variant="ghost" size="icon" className="h-7 w-7 text-muted-foreground hover:text-foreground"><Edit className="w-3.5 h-3.5" /></Button>
                      </div>
                    </td>
                  </motion.tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Orders;
